export const VIDEO_RECORDER_VIDEO_DEVICE = 'VIDEO_RECORDER_VIDEO_DEVICE';
export const VIDEO_RECORDER_AUDIO_INPUT = 'VIDEO_RECORDER_AUDIO_INPUT';
export const VIDEO_RECORDER_AUDIO_OUTPUT = 'VIDEO_RECORDER_AUDIO_OUTPUT';
export const VIDEO_PLAYER_MUTED = 'VIDEO_PLAYER_MUTED';
export const COOKIES_ACCEPTED = 'COOKIES_ACCEPTED';
